document.addEventListener('livewire:navigated', function () {
    initializeDataLayerEvents();

    function initializeDataLayerEvents() {
        'use strict';

        // CTA
        function dataLayerCTA() {
            let $this = $(this);

            let text = $this.data('dl-text');
            let type = $this.data('dl-type');

            let contents = {
                'event': 'cta_click',
                'cta': {
                    'text': (text) ? text.trim() : $this.text().trim(),
                    'type': type,
                },
            };
            dataLayer.push(contents);
        }

        $('body').off('click.dataLayerCTA').on('click.dataLayerCTA', '.js-dl-cta', dataLayerCTA);

        // Filter result click
        function filterResultDataLayerCall() {
            let $this = $(this);

            let car = $this.data('dl-car');
            let contents = {
                'event': 'filter_cars_select',
                'car': car,
            };
            dataLayer.push({ 'car': undefined });
            dataLayer.push(contents);
        }

        $('body').off('click.filterResultDataLayerCall').on('click.filterResultDataLayerCall', '.js-dl-filter-result-clicked', filterResultDataLayerCall);

        // Forms
        function dataLayerFormStart() {
            let $this = $(this);
            let $body = $('body');

            if ($body.hasClass('dl-form-started')) {
                return;
            }
            $body.addClass('dl-form-started');

            let formName = $this.data('dl-form-name');
            let contents = {
                'event': 'form_start',
                'form_name': formName
            };
            dataLayer.push(contents);
        }

        $('.js-dl-form-start').off('click.dataLayerFormStart').on('click.dataLayerFormStart', dataLayerFormStart);

        var $forms = $('.js-dl-form');
        $forms.each(function () {
            $(this).off('input.dataLayerFormStart').on('input.dataLayerFormStart', dataLayerFormStart);
        });

        // Contact form submit
        window.removeEventListener('carContactFormSubmit', carContactFormSubmitHandler);
        function carContactFormSubmitHandler(event) {
            var contents = {
                'event': 'form_submit',
            };
            dataLayer.push(contents);
        }
        window.addEventListener('carContactFormSubmit', carContactFormSubmitHandler);

        // Contact form error
        window.removeEventListener('carContactFormError', carContactFormErrorHandler);
        function carContactFormErrorHandler(event) {
            var contents = {
                'event': 'form_error',
                'error_message': event.detail.message
            };
            dataLayer.push(contents);
        }
        window.addEventListener('carContactFormError', carContactFormErrorHandler);

        // Homepage - waypoint
        function dataLayerHomepageSection(name, index) {
            dataLayer.push({ 'ecommerce': null });
            dataLayer.push({
                'event': 'section_view',
                'section': {
                    'name': name,
                    'index': index
                }
            });
        }

        $('.js-dl-section-view').waypoint(function (direction) {
            let $this = $(this.element);
            let name = $this.data('dl-name');
            let index = parseInt($this.data('dl-index'));

            dataLayerHomepageSection(name, index);
            this.destroy();
        }, {
            offset: '50%',
        });

        function dataLayerClickSection() {
            let $this = $(this);
            let name = $this.data('dl-name');
            let index = $this.data('dl-index');

            let contents = {
                'event': 'section_click',
                'section': {
                    'name': name,
                    'index': index
                }
            };
            dataLayer.push({ 'ecommerce': null });
            dataLayer.push(contents);
        }

        $('body').off('click.dataLayerClickSection').on('click.dataLayerClickSection', '.js-dl-section-click', dataLayerClickSection);

        // Sign up view
        function dataLayerSignUpView() {
            dataLayer.push({ 'ecommerce': undefined });
            dataLayer.push({ 'event': 'sign_up_view' });
        }
        $('.js-dl-signUpView').off('click.dataLayerSignUpView').on('click.dataLayerSignUpView', dataLayerSignUpView);

        // Sign in view
        function dataLayerSignInView() {
            dataLayer.push({ 'ecommerce': undefined });
            dataLayer.push({ 'event': 'login_view' });
        }
        $('.js-dl-signInView').off('click.dataLayerSignInView').on('click.dataLayerSignInView', dataLayerSignInView);

        // Password reset
        function dataLayerPasswordReset() {
            dataLayer.push({ 'ecommerce': undefined });
            dataLayer.push({ 'event': 'password_reset_start' });
        }
        $('.js-dl-passwordReset').off('click.dataLayerPasswordReset').on('click.dataLayerPasswordReset', dataLayerPasswordReset);

        // Search form
        window.removeEventListener('searchFormResultsUpdated', searchFormResultsUpdatedHandler);
        function searchFormResultsUpdatedHandler(event) {
            dataLayer.push(event.detail.payload);
        }
        window.addEventListener('searchFormResultsUpdated', searchFormResultsUpdatedHandler);

        // Car filter
        window.removeEventListener('carFilter.resultsUpdated', carFilterResultsUpdatedHandler);
        function carFilterResultsUpdatedHandler(event) {
            dataLayer.push({ 'filter': undefined, 'cars': undefined });
            dataLayer.push(event.detail.payload);
        }
        window.addEventListener('carFilter.resultsUpdated', carFilterResultsUpdatedHandler);

        // Search result clicked
        $(document).off('click.searchResultItem').on('click.searchResultItem', '.search__result-item', function (e) {
            var componentRootElement = $(this).closest('[data-livewire]');
            var LivewireComponent = eval(componentRootElement.data('livewire'));

            var term = LivewireComponent.get('search');
            var numberOfResults = LivewireComponent.get('resultsCount');

            var payload = {
                'event': 'search_click',
                'search': {
                    'term': term,
                    'result_count': numberOfResults,
                    'results': [{
                        'title': $(this).data('result-title'),
                        'position': $(this).data('result-position'),
                        'type': $(this).data('result-type')
                    }]
                }
            };
            dataLayer.push({ 'ecommerce': null });
            dataLayer.push(payload);
        });

        // Favorites
        window.removeEventListener('carAddedOrRemovedFromFavorites', carAddedOrRemovedFromFavoritesHandler);
        function carAddedOrRemovedFromFavoritesHandler(event) {
            dataLayer.push({ 'ecommerce': undefined });
            dataLayer.push(event.detail.payload);
        }
        window.addEventListener('carAddedOrRemovedFromFavorites', carAddedOrRemovedFromFavoritesHandler);

        // Comparison
        window.removeEventListener('carAddedOrRemovedFromComparison', carAddedOrRemovedFromComparisonHandler);
        function carAddedOrRemovedFromComparisonHandler(event) {
            dataLayer.push({ 'car': undefined });
            dataLayer.push(event.detail.payload);
        }
        window.addEventListener('carAddedOrRemovedFromComparison', carAddedOrRemovedFromComparisonHandler);
    }

    initializeDataLayerEvents();
});
